export default __webpack_public_path__ + "static/media/Magadhi_book_m.70d27c17.wav";